import React, { createContext, useState, useEffect } from "react";
import toast from "react-hot-toast";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Initial state based on session storage
  const sessionUser = JSON.parse(sessionStorage.getItem("user"));
  const initialAuthState = sessionUser ? true : false;

  const [isAuthenticated, setIsAuthenticated] = useState(initialAuthState);
  const [user, setUser] = useState(sessionUser);

  useEffect(() => {
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    if (sessionUser) {
      setIsAuthenticated(true);
      setUser(sessionUser);
    }
  }, []);

  const login = (userData) => {
    console.log("Logging in with userData:", userData); // Debugging
    setIsAuthenticated(true);
    setUser(userData);
    sessionStorage.setItem("user", JSON.stringify(userData));
    sessionStorage.setItem("adminToken", userData.token);
  };

  const logout = () => {
    console.log("Logging out"); // Debugging
    setIsAuthenticated(false);
    setUser(null);
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("adminToken");
    // toast.success("Logged out successfully!");
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
